/**
 * Legacy formula-to-stat mapping for persisted metrics from older worksteps.
 *
 * Before stats were parameterized, scorecard metrics stored the full Formula Engine expression
 * as `formula` and `timeUnits` separately. This map allows rehydration logic to convert those
 * legacy shapes into the current `stat` object with a `key` and `timeUnits`.
 *
 * New code should use the `stat` object directly; this map exists solely for backward compatibility.
 */
export const LEGACY_STAT_KEY_BY_FORMULA: Record<string, string> = {
  '$series.min($capsule).getValue()': 'min',
  '$series.max($capsule).getValue()': 'max',
  '$series.average($capsule)': 'average',
  '$series.standardDeviation($capsule)': 'standardDeviation',
  '$series.totalized($capsule)': 'totalized',
  '$series.rate($capsule)': 'rate',
  '$series.getValue($capsule.getStart())': 'valueStart',
  '$series.getValueAtOrBefore($capsule.getEnd())': 'valueEnd',
  '$series.delta($capsule)': 'delta',
  '$series.range($capsule)': 'range',
  '$series.sum($capsule)': 'sum',
  '$series.count($capsule)': 'count',
  '$series.getEnds().count($capsule)': 'count.ends',
  '$series.getStarts().count($capsule)': 'count.starts',
  '$series.percentDuration($capsule)': 'percentDuration',
  '$series.totalDuration($capsule)': 'totalDuration',
};
